import { WizBehaviorDirectiveModule } from './../../../directives/behavior/wiz-behavior-directives.module';
import { WizItemRendererModule } from './../../../interfaces/wiz-item-renderer';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { WizLayoutModule } from '../../layouts/wiz-layout.module';
import { WizList } from './wiz-list';
import { CollectionModule } from '../../../services/collections/collection.module';
import { WizTileList } from './wiz-tile-list';
import { VIRTUAL_SCROLLER_DEFAULT_OPTIONS_FACTORY, VirtualScrollerComponent } from './virtual-scroller';


// import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller/';
@NgModule({
  declarations: [WizList, WizTileList, VirtualScrollerComponent],
  imports: [
    CommonModule,
    ScrollingModule,
    WizLayoutModule,
    WizItemRendererModule,
    CollectionModule,
    WizBehaviorDirectiveModule,
    // VirtualScrollerModule
  ],
  exports: [WizList, WizTileList, VirtualScrollerComponent],
  providers: [
  {
    provide: 'virtual-scroller-default-options',
    useFactory: VIRTUAL_SCROLLER_DEFAULT_OPTIONS_FACTORY
  }
	]
})
export class WizListModule {}
